import type { Dict } from "mixpanel-browser";
import type { FC } from "react";
import { useEffect } from "react";
import { tracker } from "src/state/state";
import type { TrackEvent, TrackType } from "src/state/Track/TrackCubit";

const Track: FC<{
  event: TrackEvent | string;
  type?: TrackType;
  data?: Dict;
  backend?: boolean;
}> = (props) => {
  let mounted = true;
  useEffect(() => {
    // track in timeout to avoid tracking views that are immediately unmounted
    const to = setTimeout(() => {
      if (!mounted) {
        return;
      }
      tracker.track(props.event, {
        type: props.type,
        data: props.data,
        backend: props.backend
      });
    }, 400);

    return () => {
      mounted = false;
      clearTimeout(to);
    };
  }, []);

  return null;
};

export default Track;
